import type { FunctionComponent } from 'react';
import { Slider } from 'pure-react-carousel';
import styled from 'styled-components';
import { useMediaGalleryLightBoxContext } from '../../contexts/MediaGalleryLightBoxContext/MediaGalleryLightBoxContext';
import { MediaGallerySlide } from './MediaGallerySlide';
import { MediaNavigationButton } from './subcomponents/MediaNavigationButton/MediaNavigationButton';
import { isAerialImage } from '../../../app-kit/components/Image/types';

const StyledMediaGalleryCarouselContents = styled.div`
  overflow: hidden;
  width: 100%;
`;
export const MediaGalleryCarouselContents: FunctionComponent = () => {
  const { mediaItems } = useMediaGalleryLightBoxContext();

  return (
    <StyledMediaGalleryCarouselContents>
      <Slider id="media-gallery-carousel-slider" tabIndex={-1}>
        {mediaItems.map(({ image }, index) => {
          const uri = isAerialImage(image) ? image.uri : image.desktopFullScreenImageJpgUri;
          const key = [index, uri].join(':');

          return <MediaGallerySlide index={index} key={key} image={image} />;
        })}
      </Slider>
      <MediaNavigationButton />
    </StyledMediaGalleryCarouselContents>
  );
};
